import React from 'react'
import './stylesheets/Kegmeisters.css'
import kegLogo from './images/KegMeisters-web-logo.png'

export const KegImage = () => {
  return (
    <div >
      <img
        alt='kegmeisters logo'
        src={kegLogo}
        style={{ height: 130 }} />
    </div>
  )
}

export const Kegmeisters = ({ wrapperClassName, kegClassName, meistersClassName, fontSize, kegColor, meistersColor }) => {
  return (
    <div
      className={wrapperClassName}>
      <h1
        style={{
          fontSize: fontSize,
          fontWeight: 400,
          marginTop: 0,
          marginBottom: 0,
          color: kegColor
        }}
        className={kegClassName}>
        Keg
      </h1>
      <h1
        style={{
          fontSize: fontSize,
          color: meistersColor,
          fontWeight: 400,
          marginTop: 0,
          marginBottom: 0}}
        className={meistersClassName}>
        Meisters
      </h1>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Keg.js